import { render, staticRenderFns } from "./QuoteMessage.vue?vue&type=template&id=089372eb&scoped=true"
import script from "./QuoteMessage.vue?vue&type=script&lang=js"
export * from "./QuoteMessage.vue?vue&type=script&lang=js"
import style0 from "./QuoteMessage.vue?vue&type=style&index=0&id=089372eb&prod&scoped=true&lang=scss"
import style1 from "./QuoteMessage.vue?vue&type=style&index=1&id=089372eb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089372eb",
  null
  
)

export default component.exports